import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["id"],
  _excluded2 = ["onResolve", "onReject"];
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "/home/runner/work/website/website/node_modules/@babel/runtime/regenerator/index.js";
import EventEmitter from 'eventemitter3';
import uniqueId from 'lodash/uniqueId';
import { createContext, useRef, useEffect, useContext, useState, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { jsx } from 'react/jsx-runtime';
function defer() {
  var resolve = function resolve() {};
  var reject = function reject() {};
  var promise = new Promise(function () {
    var _args, _args2;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return void (_args = args, _args2 = _slicedToArray(_args, 2), resolve = _args2[0], reject = _args2[1], _args);
  });
  return {
    promise: promise,
    resolve: resolve,
    reject: reject
  };
}
var Reason = {
  Update: Symbol("update"),
  Unmount: Symbol("unmount"),
  Host: Symbol("host")
};
function eventName(containerId) {
  return "toasterhea:".concat(containerId);
}
var DiscardableContext = /*#__PURE__*/createContext([function () {}, Promise.resolve()]);
function useDiscardableEffect(fn) {
  var fnRef = useRef(fn);
  useEffect(function () {
    fnRef.current = fn;
  }, [fn]);
  var _useContext = useContext(DiscardableContext),
    _useContext2 = _slicedToArray(_useContext, 2),
    discard = _useContext2[0],
    promise = _useContext2[1];
  useEffect(function () {
    var mounted = true;
    function innerFn() {
      return _innerFn.apply(this, arguments);
    }
    function _innerFn() {
      _innerFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return promise;
            case 3:
              _context.next = 9;
              break;
            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              if (!(_context.t0 === Reason.Update)) {
                _context.next = 9;
                break;
              }
              return _context.abrupt("return");
            case 9:
              if (mounted) {
                _context.next = 11;
                break;
              }
              return _context.abrupt("return");
            case 11:
              if (!fnRef.current) {
                _context.next = 13;
                break;
              }
              return _context.abrupt("return", void fnRef.current(discard));
            case 13:
              discard();
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 5]]);
      }));
      return _innerFn.apply(this, arguments);
    }
    innerFn();
    return function () {
      mounted = false;
    };
  }, [discard, promise]);
}
var emitter;
function getEmitter() {
  if (!emitter) {
    emitter = new EventEmitter();
  }
  return emitter;
}
function InlineContainer(_ref) {
  var idProp = _ref.id,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    metadatas = _useState2[0],
    setMetadatas = _useState2[1];
  var id = useMemo(function () {
    return uniqueId(idProp);
  }, [idProp]);
  useEffect(function () {
    var mounted = true;
    var cache = {};
    function onEvent(_x) {
      return _onEvent.apply(this, arguments);
    }
    function _onEvent() {
      _onEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(metadata) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (mounted) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              setMetadatas(function (all) {
                return _objectSpread(_objectSpread({}, all), {}, _defineProperty({}, metadata.id, metadata));
              });
              cache[metadata.id] = metadata;
              _context2.prev = 4;
              _context2.next = 7;
              return metadata.deferral.promise;
            case 7:
              _context2.next = 13;
              break;
            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](4);
              if (!(_context2.t0 === Reason.Update)) {
                _context2.next = 13;
                break;
              }
              return _context2.abrupt("return");
            case 13:
              _context2.prev = 13;
              _context2.next = 16;
              return metadata.discardDeferral.promise;
            case 16:
              _context2.next = 20;
              break;
            case 18:
              _context2.prev = 18;
              _context2.t1 = _context2["catch"](13);
            case 20:
              if (mounted) {
                _context2.next = 22;
                break;
              }
              return _context2.abrupt("return");
            case 22:
              setMetadatas(function (_ref2) {
                var _metadata$id = metadata.id,
                  omit = _ref2[_metadata$id],
                  newMetadatas = _objectWithoutProperties(_ref2, [_metadata$id].map(_toPropertyKey));
                return newMetadatas;
              });
              delete cache[metadata.id];
            case 24:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[4, 9], [13, 18]]);
      }));
      return _onEvent.apply(this, arguments);
    }
    var en = eventName(idProp);
    getEmitter().on(en, onEvent);
    return function () {
      mounted = false;
      getEmitter().off(en, onEvent);
      for (var key in cache) {
        if (!Object.prototype.hasOwnProperty.call(cache, key)) {
          continue;
        }
        cache[key].deferral.reject(Reason.Unmount);
        cache[key].discardDeferral.reject();
      }
      cache = {};
    };
  }, [idProp]);
  return /*#__PURE__*/jsx("div", _objectSpread(_objectSpread({}, props), {}, {
    id: id,
    children: Object.entries(metadatas).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        _ref4$ = _ref4[1],
        C = _ref4$.component,
        innerProps = _ref4$.props,
        _ref4$$deferral = _ref4$.deferral,
        resolve = _ref4$$deferral.resolve,
        reject = _ref4$$deferral.reject,
        promise = _ref4$$deferral.promise,
        discard = _ref4$.discardDeferral.resolve;
      var _ref5 = innerProps || {},
        omit0 = _ref5.onResolve,
        omit1 = _ref5.onReject,
        rest = _objectWithoutProperties(_ref5, _excluded2);
      return /*#__PURE__*/jsx(DiscardableContext.Provider, {
        value: [discard, promise],
        children: /*#__PURE__*/jsx(C, _objectSpread(_objectSpread({}, rest), {}, {
          onResolve: resolve,
          onReject: reject
        }))
      }, key);
    })
  }));
}
function Container(props) {
  var containerRef = useRef(typeof document === "undefined" ? void 0 : document.createElement("div"));
  useEffect(function () {
    var container = containerRef.current;
    if (!container) {
      return function () {
        return void 0;
      };
    }
    document.body.appendChild(container);
    return function () {
      document.body.removeChild(container);
    };
  }, []);
  if (containerRef.current) {
    return /*#__PURE__*/createPortal( /*#__PURE__*/jsx(InlineContainer, _objectSpread({}, props)), containerRef.current);
  }
  return null;
}
function toaster(component, id) {
  var metadata;
  return {
    pop: function pop(props) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _metadata;
        var reset, _props$onResolve, result, _props$onReject;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!metadata) {
                _context3.next = 9;
                break;
              }
              _context3.prev = 1;
              metadata.deferral.reject(Reason.Update);
              _context3.next = 5;
              return metadata.deferral.promise;
            case 5:
              _context3.next = 9;
              break;
            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](1);
            case 9:
              metadata = {
                id: ((_metadata = metadata) === null || _metadata === void 0 ? void 0 : _metadata.id) || uniqueId(),
                props: props,
                component: component,
                deferral: defer(),
                discardDeferral: defer()
              };
              getEmitter().emit(eventName(id), metadata);
              reset = false;
              _context3.prev = 12;
              _context3.next = 15;
              return metadata.deferral.promise;
            case 15:
              result = _context3.sent;
              props === null || props === void 0 ? void 0 : (_props$onResolve = props.onResolve) === null || _props$onResolve === void 0 ? void 0 : _props$onResolve.call(props, result);
              reset = true;
              return _context3.abrupt("return", result);
            case 21:
              _context3.prev = 21;
              _context3.t1 = _context3["catch"](12);
              props === null || props === void 0 ? void 0 : (_props$onReject = props.onReject) === null || _props$onReject === void 0 ? void 0 : _props$onReject.call(props, _context3.t1);
              reset = _context3.t1 !== Reason.Update;
              throw _context3.t1;
            case 26:
              _context3.prev = 26;
              if (reset) {
                metadata = void 0;
              }
              return _context3.finish(26);
            case 29:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 7], [12, 21, 26, 29]]);
      }))();
    },
    discard: function discard() {
      var _metadata2;
      (_metadata2 = metadata) === null || _metadata2 === void 0 ? void 0 : _metadata2.deferral.reject(Reason.Host);
    }
  };
}
export { Container, InlineContainer, Reason, defer, toaster, useDiscardableEffect };